/*
 * This is based on
 * https://ui.reach.tech/menu-button
 *
 */
import { querySelectArray } from './utils';

const InitMobileMenus = () => {
    const buttons = querySelectArray('[data-mobilemenu-refs]', document);
    Array.from(buttons).forEach(initMobileMenu);
};

const HEADER = 'header';
const MAIN = 'main';
const FOOTER = 'footer';
const MENU_SELECTOR = 'data-mobile-menu';
const SHOW_CLASS = 'mobilemenu-dialog--show';
const KEY_ESCAPE = 27;
const KEY_UP = 38;
const KEY_DOWN = 40;
const KEY_TAB = 9;

const initMobileMenu = menuButton => {
    const menu = document.querySelector(`[${MENU_SELECTOR}]`);
    const menuContentRefs = menuButton.getAttribute('data-mobilemenu-refs');
    const dialog = document.querySelector(menuContentRefs);
    const close = dialog.querySelector('[data-mobilemenu-close]');

    const header = document.querySelector(HEADER);
    const footer = document.querySelector(FOOTER);
    const main = document.querySelector(`[role="${MAIN}"]`);

    const menuItems = querySelectArray(
        '[data-searchbox-in-mobilemenu], a, button',
        dialog,
    );

    const navItems = querySelectArray('a, button', dialog);

    navItems.forEach(menuItem =>
        menuItem.addEventListener('click', onCloseClick, false),
    );
    document.addEventListener('keydown', documentKeydown);
    dialog.addEventListener('keydown', keydown);
    dialog.addEventListener('submit', dialogClick);
    menuButton.addEventListener('click', onOpenClick, false);
    close.addEventListener('click', onCloseClick, false);
    close.addEventListener('keydown', onCloseKeyPress, false);

    dialog.style.display = 'none'; // default

    let timer;

    let state = {
        isOpen: false,
    };

    function dialogClick(e) {
        state = {
            ...state,
            isOpen: false,
        };
        render();
    }

    function dialogSubmit(e) {
        state = {
            ...state,
            isOpen: false,
        };
        render();
    }

    function onOpenClick(e) {
        state = {
            ...state,
            isOpen: true,
        };
        render();
    }

    function onCloseClick(e) {
        state = {
            ...state,
            isOpen: false,
        };
        render();
    }

    // TODO: now that we're higing desktop's main/header/footer when the menu dialog is open, we might not need SOME of this trapping/cycling code.
    function keydown(e) {
        let focusIndex;
        for (let i = 0; i < menuItems.length; i++) {
            const menuItem = menuItems[i];
            if (menuItem === e.target) {
                focusIndex = i;
            }
        }
        let target;
        if (e.keyCode === KEY_DOWN) {
            target = menuItems[focusIndex + 1] || menuItems[0];
            target.focus();
        } else if (e.keyCode === KEY_UP) {
            target =
                menuItems[focusIndex - 1] || menuItems[menuItems.length - 1];
            target.focus();
        } else if (e.keyCode === KEY_TAB && e.shiftKey) {
            e.preventDefault();
            target =
                menuItems[focusIndex - 1] || menuItems[menuItems.length - 1];
            target.focus();
        }
    }

    function onCloseKeyPress(e) {
        if (e.keyCode === KEY_TAB) {
            e.preventDefault();
            const target = menuItems[0];
            target.focus();
        }
    }

    function documentKeydown(e) {
        if (e.which === KEY_ESCAPE) {
            state = {
                ...state,
                isOpen: false,
            };
            render();
        }
    }

    function hideNonMenuItems() {
        header.classList.add('u-hide');
        footer.classList.add('u-hide');
        main.classList.add('u-hide');
    }
    function showNonMenuItems() {
        header.classList.remove('u-hide');
        footer.classList.remove('u-hide');
        main.classList.remove('u-hide');
    }

    function render() {
        if (timer) clearTimeout(timer);

        if (state.isOpen) {
            dialog.style.display = 'block';
            timer = setTimeout(() => {
                dialog.classList.add(SHOW_CLASS);
                hideNonMenuItems();
                menu.setAttribute('tabindex', '0');
                menu.focus();
            }, 60);
        } else {
            showNonMenuItems();
            dialog.classList.remove(SHOW_CLASS);
            menuButton.focus();

            timer = setTimeout(() => {
                dialog.style.display = 'none';
            }, 1000);
        }
    }
};

export default InitMobileMenus;
